import CryptoJS from "crypto-js";
import moment from 'moment-jalaali';
const hashPassword = (passwordValue) => {
    return CryptoJS.SHA256(passwordValue).toString();
};

const formatDateToString = (birthDate) => {
    const { day, month, year } = birthDate;

    const formattedDay = day.toString().padStart(2, "0"); // Convert to string and ensure 2 digits
    const formattedMonth = month.toString().padStart(2, "0"); // Convert to string and ensure 2 digits
    const formattedYear = year.toString().padStart(4, "0"); // Convert to string and ensure 4 digits

    return `${formattedYear}${formattedMonth}${formattedDay}`;
}

const formatDateToJalali = (isoDate) => {
    moment.locale("fa");
    moment.loadPersian({ usePersianDigits: true });
    const formattedDate = moment(isoDate).format("dddd jD jMMMM jYYYY HH:mm");
    return formattedDate
}
const getJalaliTime = (isoDate) => {
    moment.locale("fa");
    moment.loadPersian({ usePersianDigits: true });
    const formattedDate = moment().format("HH:mm:ss");
    return formattedDate
}
const numberToTomans = (number) => {
    const formattedNumber = new Intl.NumberFormat('en-US').format(number);
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return formattedNumber.replace(/\d/g, (digit) => persianDigits[digit]);
}
const toPersianDigits = (input) => {
    return input.toString().replace(/\d/g, (digit) => ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'][digit]);
}

const miliToGram = (input) => {
    let grams = (input / 1000).toFixed(3);
    let [whole, fraction] = grams.split(".");
    let formatted = `${whole}/${fraction}`;
    let persianDigits = formatted.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
    return persianDigits;
}
export {hashPassword, formatDateToString, formatDateToJalali, numberToTomans, toPersianDigits, getJalaliTime, miliToGram}